export default __webpack_public_path__ + "static/media/OrderStatus_3b.62de7265.svg";